import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

interface WelcomeModalProps {
  open: boolean;
  onClose: () => void;
  firstName?: string | null;
}

export function WelcomeModal({ open, onClose, firstName }: WelcomeModalProps) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-md text-center">
        <DialogHeader className="space-y-4">
          <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
            <Sparkles className="w-8 h-8 text-primary" />
          </div>
          <DialogTitle className="text-xl font-serif">
            Bienvenue{firstName ? `, ${firstName}` : ''} !
          </DialogTitle>
          <DialogDescription className="text-base">
            Votre conciergerie personnelle est prête. Découvrez nos services exclusifs et commencez à planifier vos expériences de rêve.
          </DialogDescription>
        </DialogHeader>
        <Button onClick={onClose} className="mt-4 w-full">
          Découvrir les services
        </Button>
      </DialogContent>
    </Dialog>
  );
}
